import { render, staticRenderFns } from "./MemberStatistics.vue?vue&type=template&id=cff7ad4c&"
import script from "./MemberStatistics.vue?vue&type=script&lang=js&"
export * from "./MemberStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports